export const codingLanguages = [
  {
    name: "JS",
    icon: "https://cdn-icons-png.flaticon.com/512/919/919828.png",
    type: "Multi-paradigm programming language",
    paradigm:
      "event-driven, functional, imperative, procedural, object-oriented programming",
    info: "",
    documentation: "https://developer.mozilla.org/en-US/docs/Web/JavaScript",
  },
  {
    name: "Python",
    icon: "https://www.freepngimg.com/download/android/72537-icons-python-programming-computer-social-tutorial.png",
    type: "programming language",
    paradigm:
      " Multi-paradigm: object-oriented, procedural (imperative), functional, structured, reflective",
    info: "Excited to currently be learning Python",
    documentation: "https://www.python.org/doc/essays/blurb/",
  },
  {
    name: "React",
    icon: "https://cdn.buttercms.com/cQfNWfcMSHmAZfvtloVz",
    type: "framework, JavaScript library ",
    info: "React is a free and open-source front-end JavaScript library for building user interfaces based on UI components.",
    documentation: "https://reactjs.org/tutorial/tutorial.html#what-is-react",
  },
  {
    name: "Next.js 13",
    icon: "https://tkssharma.com/static/02dfdac16100b40337b156a95ab4b1fe/56e34/nextjs.png",
    type: "framework",
    info: "Next.js is a React framework for building full-stack web applications. You use React Components to build user interfaces, and Next.js for additional features and optimizations.",
    documentation: "https://nextjs.org/docs/getting-started",
  },

  {
    name: 'Django',
    icon: 'https://static.djangoproject.com/img/logos/django-logo-negative.png',
    type: 'framework',
    for: 'Python',
    writtenIn: 'Python',
    info: 'Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design.',
    documentation: 'https://docs.djangoproject.com/en/3.2/',
  },
  {
    name: "AWS",
    icon: "https://th.bing.com/th/id/R.a6c1d39637949a370f8e93aab60a741f?rik=ABtTtCBpS8oVOw&riu=http%3a%2f%2fgisuser.com%2fwp-content%2fuploads%2f2018%2f08%2f2000px-Amazon_Web_Services_Logo.svg_.png&ehk=hQq0rohWcsyiJCNiAOwDAXgnti8Yjm0TPZJLBnIXSHM%3d&risl=&pid=ImgRaw&r=0",
    type: "cloud computing platform",
    paradigm: " ",
    info: "Amazon Web Services offers a wide range of solutions that utilize the benefits of the cloud, providing secure, easily accessible, flexible and affordable solutions.",
    documentation: "https://docs.aws.amazon.com/index.html",
  },
  {
    name: "HTML",
    icon: "https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_960_720.png",
    type: "Markup language",
    info: "",
    documentation:
      "https://developer.mozilla.org/en-US/docs/Learn/Getting_started_with_the_web/HTML_basics",
  },
  {
    name: "CSS",
    icon: "https://cdn0.iconfinder.com/data/icons/document-file-types/512/css-512.png",
    type: "Style sheet language ",
    info: "",
    documentation: "https://www.w3schools.com/css/css_intro.asp",
  },
  {
    name: "TailWind",
    icon: "https://creazilla-store.fra1.digitaloceanspaces.com/icons/3257079/file-type-tailwind-icon-md.png",
    type: "Style Language with HTML",
    info: "",
    documentation: "https://tailwindcss.com/docs/installation",
  },

  {
    name: "Node.js",
    icon: "https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png",
    type: "runtime",
    info: "An asynchronous event-driven JavaScript runtime, Node.js is designed to build scalable network applications. ",
    documentation: "https://nodejs.dev/learn",
  },
  {
    name: "ExpressJS",
    icon: "https://www.mementotech.in/assets/images/icons/express.png",
    type: "framework",
    for: "Node.js",
    writtenIn: "JavaScript",
    info: "A back end web application framework for Node.js, designed for building web applications and APIs.",
    documentation:
      "https://developer.mozilla.org/en-US/docs/Learn/Server-side/Express_Nodejs/Introduction",
  },
  {
    name: "Bash Linux",
    icon: "https://www.linuxjournal.com/sites/default/files/styles/360_250/public/nodeimage/story/bash-icon_0.png?itok=JZG6p4sq",
    type: "CLI",
    info: "Bash is a Unix shell and command language",
    documentation: "https://devdocs.io/bash/",
  },
 
 
  // {
  //   name: "TS",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1200px-Typescript_logo_2020.svg.png",
  //   type: "Multi-paradigm programming language",
  //   paradigm: " functional, generic, imperative, object-oriented",
  //   info: "",
  //   documentation: "https://www.w3schools.com/typescript/typescript_intro.php",
  // },
 
  {
    name: "SASS",
    icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Sass_Logo_Color.svg/2560px-Sass_Logo_Color.svg.png",
    type: "scripting language, Style sheet language",
    info: "",
    documentation: "https://www.w3schools.com/sass/sass_intro.php",
  },
  {
    name: "jQuery",
    icon: "https://icon-library.com/images/jquery-icon-png/jquery-icon-png-28.jpg",
    type: "JavaScript library",
    info: "",
    documentation: "https://developer.mozilla.org/en-US/docs/Glossary/jQuery",
  },
  {
    name: "socket.io",
    icon: "https://seeklogo.com/images/S/socketio-logo-B8A7F486CD-seeklogo.com.png",
    type: "dependency",
    info: "Socket.IO is an event-driven library for real-time web applications. It enables real-time, bi-directional communication between web clients and servers. ",
    documentation: "https://socket.io/docs/v4/",
    
  },
  {
    name: "WebRtc",
    icon: "https://th.bing.com/th/id/R.681a207f9d0119a01cb817c17a90caa9?rik=Tmv1dh9PjScvlg&riu=http%3a%2f%2fwww.9and9.com%2fimage%2fwebrtc.png&ehk=wv0%2bQ26hTe0lhXIz1VgWGIK4SHkGq2UXl1uGtzE0QCg%3d&risl=&pid=ImgRaw&r=0&sres=1&sresct=1",
    type: "dependency",
    info: "WebRTC is a free and open-source project providing web browsers and mobile applications with real-time communication (RTC) via application programming interfaces.",
    documentation: "https://webrtc.org/",
    
  },
  {
    name: "Mongoose",
    icon: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/mongoose/mongoose.png",
    type: "programming library",
    WrittenIn: "JavaScript",
    info: "Mongoose is a Node.js-based Object Data Modeling (ODM) library for MongoDB. It is akin to an Object Relational Mapper (ORM) such as. SQLAlchemy. for traditional SQL databases. The problem that Mongoose aims to solve is allowing developers to enforce a specific schema at the application layer.",
    documentation: "https://mongoosejs.com/docs/api.html",
  },
  // {
  //   name: "GraphQL",
  //   icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/GraphQL_Logo.svg/1024px-GraphQL_Logo.svg.png",
  //   type: "data querying language, runtime",
  //   writtenIn: " Java, JavaScript, Ruby, Scala, others",
  //   info: "GraphQL is a query language for APIs and a runtime for fulfilling those queries with your existing data. ",
  //   documentation: "https://graphql.org/",
  // },
  // {
  //   name: "Apollo",
  //   icon: "https://cdn.worldvectorlogo.com/logos/apollo-graphql-compact.svg",
  //   type: "state management library",
  //   for: { framework: ["React", "iOS", "Kotlin"] },
  //   info: "Apollo is a platform for building a supergraph, a unified network of all your data, services, and capabilities that connects to your application clients (such as web and native apps). At the heart of the supergraph is a query language called GraphQL.",
  //   documentation: "https://www.apollographql.com/docs/",
  // },
  // {
  //   name: "Prisma",
  //   icon: "https://www.freelogovectors.net/wp-content/uploads/2022/01/prisma_logo-freelogovectors.net_.png",
  //   type: "ORM",
  //   compatibleWith: {
  //     languages: ["JavaScript", "TypeScript"],
  //     databases: [
  //       "postgreSQL",
  //       "MySQL",
  //       "SQL Server",
  //       "SQLite",
  //       "MongoDB",
  //       "CockroachDB",
  //       "Planetscale",
  //     ],
  //     frameworks: [
  //       "NextJS",
  //       "NestJS",
  //       "Apollo",
  //       "Hapi",
  //       "GraphQL",
  //       "ExpressJs",
  //     ],
  //   },
  //   info: "Prisma is a next-generation ORM that consists of Prisma Client: Auto-generated and type-safe query builder for Node.js & TypeScript, Prisma Migrate: Declarative data modeling & migration system, Prisma Studio: GUI to view and edit data in your database. ",
  //   documentation: "https://github.com/prisma/prisma#what-is-prisma",
  // },

  {
    name: "Shopify Liquid",
    icon: "https://parse.programmieren-muenchen.de/parse/files/unilearn/liquid-logo-text.png",
    type: "template engine",
    for: "Shopify",
    writtenIn: "Ruby",
    info: "Liquid is an open-source template language created by Shopify and written in Ruby.",
    documentation: "https://shopify.github.io/liquid/",
  },
  {
    name: "Vercel",
    icon: "https://assets.vercel.com/image/upload/front/favicon/round-2/180x180.png",
    type: "app hosting service",    
    info: "Vercel is an end-to-end platform for developers, that allows you to create and deploy your web application. ",
    documentation: "https://vercel.com/docs",
  },
  {
    name: "Heroku",
    icon: "https://gluonhq.com/wp-content/uploads/2018/05/heroku-logotype-vertical-purple.png",
    type: "app hosting service",    
    info: "Heroku makes it easy to deploy and scale Node.js applications.  ",
    documentation: "https://devcenter.heroku.com/categories/reference",
  },
  // {
  //   name: "React Native",
  //   icon: "https://svgarchive.com/wp-content/uploads/react-native.svg",
  //   type: "framework, JavaScript library ",
  //   for: "Android, Android TV, iOS, macOS, tvOS, Web, Windows, UWP ",
  //   writtenIn: "JavaScript, Java, C++, Objective-C, Python",
  //   info: "React Native is a JavaScript framework for writing real, natively rendering mobile applications for iOS and Android. It's based on React.",
  //   documentation: "https://reactnative.dev/docs/getting-started",
  // },
  {
    name: "MongoDB",
    icon: "https://www.svgviewer.dev/static-svgs/34566/mongodb.svg",
    type: "database, NoSQL database program",
    WrittenIn: "C++, JavaScript, Python",
    info: "MongoDB Atlas is a fully-managed cloud database that handles all the complexity of deploying, managing, and healing your deployments on the cloud service provider of your choice (AWS , Azure, and GCP). ",
    documentation:
      "https://mongodb.github.io/node-mongodb-native/3.1/tutorials/main/",
    documentation2: "https://www.mongodb.com/docs/manual/core/gridfs/",
  },
  {
    name: "VPC",
    icon: "https://th.bing.com/th/id/R.af278fa03c11433f463947ba9d79bbf3?rik=ZXzsPdSYtRMtcA&pid=ImgRaw&r=0",
    type: "Virtual Private Cloud",
    Model: "IaaS",
    resourceType: "Network",
    info: "The foundation of your cloud. A VPC is a logically isolated part of your cloud network that hosts your cloud resources",
    documentation: "https://aws.amazon.com/vpc/",
  },
  {
    name: "EC2",
    icon: "https://s28309.pcdn.co/wp-content/themes/321-web-marketing/assets/images/ec2-logo-256.png",
    type: "Amazon Compute Service",
    Model: "IaaS",
    resourceType: "Compute",
    info: "Cloud Computing Service offered by AWS. EC2s are powerful computing resources that can be configured to your specific requirements",
    documentation: "https://aws.amazon.com/de/ec2/",
  },
  {
    name: "S3",
    icon: "https://i0.wp.com/engineer-log.net/wp-content/uploads/2016/11/AWS_Simple_Icons_Storage_Amazon_S3_Bucket_with_Objects.svg.png?fit=1200%2C1200&ssl=1",
    type: "Amazon Object Storage Service",
    Model: "IaaS",
    resourceType: "Object Storage",
    info: "A Cloud Object Storage Service offered by AWS. S3 are powerful resources that can be used to store various types of data securely, from media to text files and made available globally within seconds",
    documentation: "https://aws.amazon.com/de/s3/",
  },
  {
    name: "EBS",
    icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/AWS_Simple_Icons_Storage_Amazon_EBS.svg/600px-AWS_Simple_Icons_Storage_Amazon_EBS.svg.png",
    type: "Amazon Block Storage Service",
    Model: "IaaS",
    resourceType: "Block Storage",
    info: "A Block Storage Service offered by AWS. EBS provides raw block storage volume that can be attached to an EC2. The storage with EBS is persistent",
    documentation: "https://aws.amazon.com/de/ebs/",
  },
  {
    name: "EFS",
    icon: "https://www.nubersia.com/wp-content/uploads/2017/07/EFS-600x400-2.png",
    type: "Amazon File Storage Service",
    Model: "IaaS",
    resourceType: "File Storage",
    info: "Amazon EFS is a service that provides scalable and elastic file storage for Amazon EC2 instances and other AWS services. It supports the Network File System version 4(NFSv4) protocol, so you can use your existing applications and tools with Amazon EFS",
    documentation: "https://aws.amazon.com/de/efs/",
  },
  {
    name: "RDS",
    icon: "https://intellipaat.com/blog/wp-content/uploads/2019/05/RDS.png",
    type: "AWS Database Solutions",
    Model: "Serverless, PaaS",
    resourceType: "Database",
    info: "AWS RDS is a fully managed service that supports various relational database engines such as Amazon Aurora, MySQL, PostgreSQL, Oracle, and SQL Server.",
    documentation: "https://aws.amazon.com/de/rds/",
  },
  {
    name: "DynamoDB",
    icon: "https://th.bing.com/th/id/OIP.FTNVce-Qz9mQONdYIziYiAAAAA?pid=ImgDet&rs=1",
    type: "AWS Database Solutions",
    Model: "Serverless, PaaS",
    resourceType: "Database",
    info: " DynamoDB is a managed NoSQL database service that offers high-performance and scalability for key-value and document data models",
    documentation: "https://aws.amazon.com/dynamodb/",
  },
  {
    name: "DocumentDB",
    icon: "https://res.cloudinary.com/hy4kyit2a/f_auto,fl_lossy,q_70/learn/modules/core-aws-services/manage-databases-on-aws/images/a5b15f3f330bed3cc5c6efb961c39c78_ce-457896-63-ab-423-a-ba-80-1153-aff-22-b-55.png",
    type: "AWS Database Solutions",
    Model: "Serverless, PaaS",
    resourceType: "Database",
    info: "Document DB is a native JSON document database that is compatible with MongoDB and supports document data models",
    documentation: "https://aws.amazon.com/documentdb/",
  },
 
];
